import React, { useState } from "react";
import { UncontrolledTooltip } from "reactstrap";

let infoTipCount = 0;

// Info icon with a tooltip.
const InfoTip = ({ text }) => {
  const [id] = useState(() => `info-tip-${(infoTipCount += 1)}`);
  return (
    <>
      <i
        id={id}
        className="ri-information-line text-muted ms-1 align-middle"
        role="img"
        aria-label={text}
        tabIndex={0}
        style={{ cursor: "help" }}
        onClick={(e) => e.stopPropagation()}
      ></i>
      <UncontrolledTooltip target={id} placement="top">
        {text}
      </UncontrolledTooltip>
    </>
  );
};

export default InfoTip;
